import * as type from '../../../actions/index.types'

const initialState = {
    loading: false,
    detailsLoading: false,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    accountHeadsLoading: false,
    auditLogsLoading: false,
    bulkValidateLoading: false,
    bulkUploadLoading: false,
    coaDropdownLoading: false,
    journalsData: null,
    journalDetails: null,
    accountHeads: null,
    auditLogs: null,
    auditLogsPagination: null,
    bulkValidateResult: null,
    bulkUploadResult: null,
    pagination: null,
    coaDropdown: [],
    error: null
};

export function JournalReducer(state = initialState, action) {

    switch (action.type) {
        // Get Journals
        case type.GET_JOURNALS:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.GET_JOURNALS_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                journalsData: action.payload?.data,
                pagination: action.payload?.pagination,
            }
        }
        case type.GET_JOURNALS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        // Get Journal Details
        case type.GET_JOURNAL_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                journalDetails: null,
                error: null,
            }
        case type.GET_JOURNAL_DETAILS_SUCCESS: {
            return {
                ...state,
                error: null,
                detailsLoading: false,
                journalDetails: action.payload,
            }
        }
        case type.GET_JOURNAL_DETAILS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                detailsLoading: false,
            }

        // Create Journal
        case type.CREATE_JOURNAL:
            return {
                ...state,
                createLoading: true,
                error: null,
            }
        case type.CREATE_JOURNAL_SUCCESS: {
            return {
                ...state,
                error: null,
                createLoading: false,
            }
        }
        case type.CREATE_JOURNAL_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createLoading: false,
            }

        // Update Journal
        case type.UPDATE_JOURNAL:
            return {
                ...state,
                updateLoading: true,
                error: null,
            }
        case type.UPDATE_JOURNAL_SUCCESS: {
            return {
                ...state,
                error: null,
                updateLoading: false,
            }
        }
        case type.UPDATE_JOURNAL_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                updateLoading: false,
            }

        // Delete Journal
        case type.DELETE_JOURNAL:
            return {
                ...state,
                deleteLoading: true,
                error: null,
            }
        case type.DELETE_JOURNAL_SUCCESS: {
            return {
                ...state,
                error: null,
                deleteLoading: false,
            }
        }
        case type.DELETE_JOURNAL_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                deleteLoading: false,
            }

        // Get Account Heads
        case type.GET_ACCOUNT_HEADS:
            return {
                ...state,
                accountHeadsLoading: true,
                error: null,
            }
        case type.GET_ACCOUNT_HEADS_SUCCESS: {
            return {
                ...state,
                error: null,
                accountHeadsLoading: false,
                accountHeads: action.payload,
            }
        }
        case type.GET_ACCOUNT_HEADS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                accountHeadsLoading: false,
            }

        // Get Journal Audit Logs
        case type.GET_JOURNAL_AUDIT_LOGS:
            return {
                ...state,
                auditLogsLoading: true,
                auditLogs: null,
                auditLogsPagination: null,
                error: null,
            }
        case type.GET_JOURNAL_AUDIT_LOGS_SUCCESS: {
            return {
                ...state,
                error: null,
                auditLogsLoading: false,
                auditLogs: action.payload?.audit_logs,
                auditLogsPagination: {
                    currentPage: action.payload?.current_page,
                    totalPages: action.payload?.total_pages,
                    totalCount: action.payload?.total_count,
                    limit: action.payload?.page_limit,
                },
            }
        }
        case type.GET_JOURNAL_AUDIT_LOGS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                auditLogsLoading: false,
                auditLogs: [],
            }

        // Clear Journal Details
        case type.CLEAR_JOURNAL_DETAILS:
            return {
                ...state,
                journalDetails: null,
                detailsLoading: false,
            }

        // Clear Journal Audit Logs
        case type.CLEAR_JOURNAL_AUDIT_LOGS:
            return {
                ...state,
                auditLogs: null,
                auditLogsPagination: null,
                auditLogsLoading: false,
            }

        // Bulk Validate Journals
        case type.BULK_VALIDATE_JOURNALS:
            return {
                ...state,
                bulkValidateLoading: true,
                bulkValidateResult: null,
                error: null,
            }
        case type.BULK_VALIDATE_JOURNALS_SUCCESS:
            return {
                ...state,
                bulkValidateLoading: false,
                bulkValidateResult: action.payload,
            }
        case type.BULK_VALIDATE_JOURNALS_FAILURE:
            return {
                ...state,
                bulkValidateLoading: false,
                error: action?.message || 'Validation failed.',
            }

        // Bulk Upload Journals
        case type.BULK_UPLOAD_JOURNALS:
            return {
                ...state,
                bulkUploadLoading: true,
                bulkUploadResult: null,
                error: null,
            }
        case type.BULK_UPLOAD_JOURNALS_SUCCESS:
            return {
                ...state,
                bulkUploadLoading: false,
                bulkUploadResult: action.payload,
            }
        case type.BULK_UPLOAD_JOURNALS_FAILURE:
            return {
                ...state,
                bulkUploadLoading: false,
                error: action?.message || 'Upload failed.',
            }

        // Clear Bulk Import State
        case type.CLEAR_BULK_IMPORT_STATE:
            return {
                ...state,
                bulkValidateLoading: false,
                bulkUploadLoading: false,
                bulkValidateResult: null,
                bulkUploadResult: null,
            }

        // Chart of Accounts Dropdown
        case type.GET_CHART_OF_ACCOUNTS_DROPDOWN:
            return { ...state, coaDropdownLoading: true }
        case type.GET_CHART_OF_ACCOUNTS_DROPDOWN_SUCCESS:
            return { ...state, coaDropdownLoading: false, coaDropdown: action.payload || [] }
        case type.GET_CHART_OF_ACCOUNTS_DROPDOWN_FAILURE:
            return { ...state, coaDropdownLoading: false }

        // Clear State
        case type.CLEAR_JOURNAL_STATE:
            return initialState;

        default:
            return state
    }
}
